<template>
  <div>

 

          <div class="input-daterange form-group row">
              <div class="input-date-time-picker" >
                  <div class="col-xs-12">
                          <div class="col-lg-4 col-md-6 col-xs-12">
                              <div class="col-md-6">
                                  <label for="startDateTime">{{ labelStartDate[actualLanguage] }}</label>
                                  <date-picker
                                      class="el-input__inner form-control"
                                      v-model="myStartDate"
                                      type="date"
                                      placeholder=""
                                      clear-icon=""
                                      format="yyyy-MM-dd"
                                      value-format="timestamp"
                                  />
                              </div>
                              <div class="col-md-6">
                                  <label for="startDateTime">{{ labelStartTime[actualLanguage] }}</label>
                                  <time-select
                                      v-model="startTime"
                                      placeholder=""
                                      clear-icon=""
                                      :picker-options="{
                                          start: '00:00',
                                          step: '01:00',
                                          end: '24:00'
                                      }"
                                  />
                              </div>
                          </div>

                          <div class="col-lg-4 col-md-6 col-xs-12">
                              <div class="col-md-6">
                                  <label for="startDateTime">{{ labelEndDate[actualLanguage] }}</label>
                                  <date-picker
                                      class="el-input__inner form-control"
                                      v-model="myEndDate"
                                      type="date"
                                      placeholder=""
                                      clear-icon=""
                                      format="yyyy-MM-dd"
                                      value-format="timestamp"
                                  />
                              </div>
                              <div class="col-md-6">
                                  <label for="startDateTime">{{ labelEndTime[actualLanguage] }}</label>
                                  <time-select
                                      v-model="endTime"
                                      placeholder=""
                                      clear-icon=""
                                      :picker-options="{
                                          start: '00:00',
                                          step: '01:00',
                                          end: '24:00'
                                      }"
                                  />
                              </div>
                          </div>
                      

                          <div class="col-lg-4 col-md-6 col-xs-12">
                              <div class="col-xs-6">
                                <label class="col-xs-12">{{labelDataSamplingTitle[actualLanguage]}}</label>
                                  <select class="form-control" v-model=dataSamplingSelect size="1">
                                      <option value="Automatic">{{labelDataSamplingAuto[actualLanguage]}}</option>
                                      <option value="5min">{{labelDataSampling5min[actualLanguage]}}</option>
                                      <option value="Hour">{{labelDataSamplingHour[actualLanguage]}}</option>
                                      <option value="Day">{{labelDataSamplingDays[actualLanguage]}}</option>
                                  </select>
                              </div>

                              <div class="col-xs-6">
                                  <button type="button" @click="refreshGraph()" class="btn btn-success" name="button"><spinner size="small" v-if="flagGraphDataIsLoading"></spinner>
                                  <span v-else><i class="fa fa-repeat pull-left"></i>{{ labelButtonRefresh[actualLanguage] }}</span></button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>




            <div class="col-sm-12">

              <div class="col-sm-12 col-md-4">
                  <div class="block block-rounded">
                    <div class="block-content text-center"> 
                      <i class="fa fa-bolt fa-3x text-success"></i>
                      <p><span class="h5 text">{{ labelGraphPeakCurrent[actualLanguage] }}</span></p>
                      <p class="h4 font-w700">{{maxCurrent}} <span class="h4 text">A</span></p>
                    </div>
                  </div>
              </div>



              <div class="col-sm-12 col-md-4">
                  <div class="block block-rounded">
                    <div class="block-content text-center">
                      <i class="fa fa-money fa-3x text-success"></i>
                      <p v-if="actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png'"><span class="h5 text-muted">{{ labelGraphSaving[actualLanguage] }}</span></p>
                      <p v-else><span class="h5 text-muted">{{ labelGraphCost[actualLanguage] }}</span></p>
                      <p class="h4 font-w700">{{sumCost}}$ <span class="h4 text-muted"></span></p>
                    </div>
                  </div>
              </div>



              <div class="col-sm-12 col-md-4">
                  <div class="block block-rounded">
                    <div class="block-content text-center">
                      <i class="fa fa-download fa-3x text-success"></i>
                      <p v-if="actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png'"><span class="h5 text-muted">Production</span></p>
                      <p v-else><span class="h5 text-muted">{{ labelGraphConsumption[actualLanguage] }}</span></p>
                      <p class="h4 font-w700">{{sumKWH}} <span class="h4 text-muted">kWh</span></p>
                    </div>
                  </div>
              </div>

            </div>





    <div v-if="flagDisplayGraph" class="col-xs-12 col-sm-12">


      <!-- ============================================================ -->
      <!-- AFFICHAGE DE LA ANCIENNE VERSION DE GRAPHIQUE -->
      <!-- ============================================================ -->
      <div v-if="flagDisplayOldGraphVersion" class="col-xs-12 col-sm-12">
        <!-- AFFICHAGE DE L'ANCIENNE VERSION DE GRAPHIQUE -->

        <div class="col-sm-12">
          <select @change="changeDataForGraph" v-model="selectedDataType" class="js-select2">
            <option value="avrPower">{{ labelSelectorAvrPower[actualLanguage] }}</option>
            <option value="peak">{{ labelSelectorPeakPower[actualLanguage] }}</option>
            <option value="kwh">{{ labelSelectorKWH[actualLanguage] }}</option>
            <option value="cost">{{ labelSelectorCost[actualLanguage] }}</option>
            <option value="cumSumKwh">{{ labelSelectorCumSumKWH[actualLanguage] }}</option>
            <option value="cumSumCost">{{ labelSelectorCumSumCost[actualLanguage] }}</option>
          </select>
          <line-chart :chartData="crunchedPowerCall" ></line-chart>
        </div>



        <div class="col-sm-12" v-if = "profileData.rights.rights.logWeatherFlag">
          <select v-if="showWeatherSelector" @change="changeDataForWeatherGraph" v-model="selectedWeatherType" class="js-select2">
            <option v-if="selectedWeatherType==='none'" value="none">{{ labelSelectorSelectWeather[actualLanguage] }}</option>
            <option v-if="showWeatherGraph" value="none">{{ labelSelectorUnSelectWeather[actualLanguage] }}</option>
            <option value="temperature">{{ labelSelectorTemperature[actualLanguage] }}</option>
            <option value="humidity">{{ labelSelectorHumidity[actualLanguage] }}</option>
            <option value="cloud">{{ labelSelectorCloud[actualLanguage] }}</option>
            <option value="wind">{{ labelSelectorWind[actualLanguage] }}</option>
          </select>
          
          <line-chart v-if="showWeatherGraph" :chartData="crunchedWeatherCall"></line-chart>
        </div>

        <div class="col-sm-12">
            <div class="col-xm-12 col-sm-3">
                <label class="align-right">{{ labelTimeSpan[actualLanguage] }}</label>
            </div>
            <div class="col-xm-12 col-sm-9">
                <div class="col-sm-9">
                    <input type="range" @change="sliderChange()" class="custom-range" id="customRange1" v-model="graphTimeSpan">
                </div>
                <div class="col-sm-3">
                    <label>{{graphTimeSpan}}/100%</label>
                </div> 
            </div>                               
        </div>
        <div class="col-sm-12">
            <div class="col-xm-12 col-sm-3">
                <label class="align-right">{{ labelTimeCenter[actualLanguage] }}</label>
            </div>
            <div class="col-xm-12 col-sm-9">
                <div class="col-sm-9">
                    <input type="range" @change="sliderChange()" class="custom-range" id="customRange1" v-model="graphTimeCenter">
                </div>
                <div class="col-sm-3">
                    <label>{{graphTimeCenter}}/100%</label>
                </div>
            </div>                               
        </div>
      </div>

      <!-- ============================================================ -->
      <!-- AFFICHAGE DE LA NOUVELLE VERSION DE GRAPHIQUE -->
      <!-- ============================================================ -->
      <div v-if="flagDisplayNewGraph" class="col-xs-12 col-sm-12">
        
        <div class="col-sm-12 col-lg-9">
          <div id="chart">
            <apexchart type="area" height="350" :options="chartOptions" :series="chartDataSeries"></apexchart>
          </div>
        </div>
        <div class="col-sm-12 col-lg-3 align-center">

            <div align="left" class="col-xs-12">
                <label class="css-input css-checkbox css-checkbox-success" >
                    <input @change="refreshNewGraphData" type="checkbox" checked v-model="selectAvrPower">
                    <span></span> {{ labelSelectorAvrPowerKW[actualLanguage] }}
                </label>
            </div>
            
            <div align="left" class="col-xs-12">
                <label class="css-input css-checkbox css-checkbox-success" >
                    <input @change="refreshNewGraphData" type="checkbox" checked v-model="selectPeakPower">
                    <span></span> {{ labelSelectorPeakPowerKW[actualLanguage] }}
                </label>
            </div>

            <div align="left" class="col-xs-12">
                <label class="css-input css-checkbox css-checkbox-success" >
                    <input @change="refreshNewGraphData" type="checkbox" checked v-model="selectKWH">
                    <span></span> {{ labelSelectorKWHShort[actualLanguage] }}
                </label>
            </div>

            <div align="left" class="col-xs-12">
                <label class="css-input css-checkbox css-checkbox-success" >
                    <input @change="refreshNewGraphData" type="checkbox" checked v-model="selectCost">
                    <span></span> {{ labelSelectorCostShort[actualLanguage] }}
                </label>
            </div>

            <div align="left" class="col-xs-12">
                <label class="css-input css-checkbox css-checkbox-success" >
                    <input @change="refreshNewGraphData" type="checkbox" checked v-model="selectCumSumKwh">
                    <span></span> {{ labelSelectorCumSumKWHShort[actualLanguage] }}
                </label>
            </div>

            <div align="left" class="col-xs-12">
                <label class="css-input css-checkbox css-checkbox-success" >
                    <input @change="refreshNewGraphData" type="checkbox" checked v-model="selectCumSumCost">
                    <span></span> {{ labelSelectorCumSumCostShort[actualLanguage] }}
                </label>
            </div>


        </div>
      </div>


      <div class="col-xs-12 col-sm-12 align-center">
        <download-csv class = "btn btn-default" :data = "portData.slice(graphStartIndex,graphLastIndex)" name = "ChannelMeasurementData.csv"><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownloadData[actualLanguage]}}</download-csv>
      </div>
    </div>






    <!-- Affichage du graphique -->
    <div v-if="flagDisplayGraph" class="block-content text-left" >
      <div v-if = "profileData.rights.rights.dashboardDataTableFlag" class="col-xs-12">
        <h4 >{{ textSectionTableau[actualLanguage] }}</h4>
          <div  class="block">
          <div class="block-content">
            <data-table :tableData="portData.slice(graphStartIndex,graphLastIndex)" ></data-table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>




<script>
//https://www.digitalocean.com/community/tutorials/vuejs-vue-chart-js
import LineChart from '@/components/LineChart'
import DataTable from './DataTable'
import Spinner from '../../../components/Spinner.vue'
import {mapState, mapActions, mapGetters} from 'vuex'
import _ from 'underscore'
import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)



let defaultGraphOptions = {
  backgroundColor: 'rgba(70, 195, 123, 0.8)',
  borderColor: 'rgba(5, 210, 92, .25)',
  pointBackgroundColor: 'rgba(68, 180, 166, 1)',
  pointBorderColor: '#fff',
  pointHoverBackgroundColor: '#fff',
  pointHoverBorderColor: 'rgba(68, 180, 166, 1)'
}
export default {
  props: ['channelIndex'],
  data() {
    return {

      portData : [],
      selectedDataType: 'avrPower',
      selectedWeatherType: 'none',
      showWeatherSelector: _.map(this.portData, function(data){ return data.temperature; }).slice(0,1) > -50,
      showWeatherGraph: false,
      displayDataTable : false,
      flagDisplayGraph : false,
      flagDisplayOldGraphVersion : false,

      //Variable de sélection pour visualiser une sous section
      graphTimeSpan : 100,
      graphTimeCenter : 50,
      graphStartIndex : 0,
      graphLastIndex : 100,

      labelTimeSpan: {FR: 'Plage de temps (%)', EN: 'Time span (%)'},
      labelTimeCenter: {FR: 'Centre de temps (%)', EN: 'Time center (%)'},

      //---------------------------------------------------------------
      //Variables for the date range picker
      //---------------------------------------------------------------
      cumulativeSumKWH : [],
      cumulativeSumCost : [],
      maxCurrent:0,
      sumCost:0,
      sumKWH:0,
      flagGraphDataIsLoading : false,
      labelGraphPeakCurrent: {FR: 'Courant maximum', EN: 'Max current'},
      labelGraphCost: {FR: 'Coût', EN: 'Cost'},
      labelGraphSaving: {FR: 'Économies', EN: 'Savings'},
      labelGraphConsumption: {FR: 'Consommation', EN: 'Consumption'},
      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      dataSamplingSelect : 'Automatic',
      myStartDateTime : this.startDate,
      myEndDateTime : this.endDate,
      labelStartDate: {FR: 'Date de début', EN: 'Start date'},
      labelStartTime: {FR: 'Heure de début', EN: 'Start time'},
      labelEndDate: {FR: 'Date de fin', EN: 'End date'},
      labelEndTime: {FR: 'Heure de fin', EN: 'End time'},
      labelButtonRefresh: {FR: 'Rafraichir', EN: 'Refresh'},
      labelDataSamplingTitle: {FR: 'Type de données :', EN: 'Data type :'},
      labelDataSamplingAuto: {FR: 'Automatique', EN: 'Automatic'},
      labelDataSampling5min: {FR: '5 minutes', EN: '5 minute'},
      labelDataSamplingHour: {FR: 'Heure', EN: 'Hour'},
      labelDataSamplingDays: {FR: 'Jour', EN: 'Days'},
      //---------------------------------------------------------------



      actualLanguage : "FR",
      labelSelectorAvrPower: {FR: 'Puissance Moyenne (W)', EN: 'Average Power (W)'},
      labelSelectorAvrPowerKW: {FR: 'Puissance Moyenne (kW)', EN: 'Average Power (kW)'},
      labelSelectorPeakPower: {FR: 'Appel de puissance (W)', EN: 'Peak Power (W)'},
      labelSelectorPeakPowerKW: {FR: 'Puissance crête (kW)', EN: 'Peak Power (kW)'},
      labelSelectorKWH: {FR: 'Consommation par mesure (kWh)', EN: 'Consumption per sample (kWh)'},
      labelSelectorKWHShort: {FR: 'kWh par mesure', EN: 'kWr per sample'},
      labelSelectorCost: {FR: 'Consommation par mesure ($)', EN: 'Consumption per sample ($)'},
      labelSelectorCostShort: {FR: 'Coût par mesure ($)', EN: 'Cost per sample ($)'},
      labelSelectorCumSumKWH: {FR: 'Consommation cumulée (kWh)', EN: 'Cumulated consumption (kWh)'},
      labelSelectorCumSumKWHShort: {FR: 'kWh cumulée', EN: 'Cumulated kWh'},
      labelSelectorCumSumCost: {FR: 'Consommation cumulée ($)', EN: 'Cumulated consumption ($)'},
      labelSelectorCumSumCostShort: {FR: 'Coût cumulée ($)', EN: 'Cumulated cost ($)'}, 

      labelSelectorSelectWeather: {FR: 'Choisir données météo', EN: 'Select weather condition'},
      labelSelectorUnSelectWeather: {FR: 'Retirer données météo', EN: 'Remove weather display'},
      labelSelectorTemperature: {FR: 'Température (C)', EN: 'Temperature (C)'},
      labelSelectorHumidity: {FR: 'Humidité (%)', EN: 'Humidity (%)'},
      labelSelectorCloud: {FR: 'Ennuagement (%)', EN: 'Cloudy (%)'},
      labelSelectorWind: {FR: 'Vent (km/h)', EN: 'Wind speed (km/h)'},

      labelButtonDownloadData: {FR: 'Télécharger les données', EN: 'Download data'},
      textSectionTableau:{FR: "Tableau des mesures", EN: 'Measurement table'},


      crunchedPowerCall: {
        labels: _.map(this.portData, function(data){ return data.timestamp; }),
        //labels: _.map(this.portData, function(data){ return data.timestamp; }),
        datasets: [{
          label: 'Mesure',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: _.map(this.portData, function(data){ return data.avrPower; })
        }]
      },

      crunchedWeatherCall: {
        labels: _.map(this.portData, function(data){ return data.timestamp; }),
        //labels: _.map(this.portData, function(data){ return data.timestamp; }),
        datasets: [{
          label: 'Meteo',
          backgroundColor: 'rgba(18, 35, 240, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(18, 35, 240, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(18, 35, 240, 1)',
          data: _.map(this.portData, function(data){ return data.temperature; })
        }]
      },


      //--------------------------------------------------------
      //New Graph variables
      //--------------------------------------------------------
      selectAvrPower : true,
      selectPeakPower : true,
      selectKWH : false,
      selectCost : false,
      selectCumSumKwh : false,
      selectCumSumCost : false,
      selectTemperature : false,
      selectHumidity : false,
      selectCloud : false,
      selectWind : false,


      flagDisplayNewGraph : false,
      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54],[1326236400000, 43],[1326236405000, 43],[1326236406000, 53],[1326236406500, 63]],
      }],
        
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        tooltip:{
            x :{format : 'dd MMM hh:mm'}
          },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          },
        },
        xaxis: {
            type: 'datetime'
          }
      },





    }
  },


  components: {
    LineChart,
    DataTable,
    DatePicker,
    TimePicker,
    TimeSelect,
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['profileData','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },

  methods: {

    sliderChange(){
      this.changeDataForGraph(this.selectedDataType)
      this.changeDataForWeatherGraph(this.selectedWeatherType)
    },

    changeDataForGraph(value) {
      let changedData = []

      let firstIndex = 0
      let lastIndex = _.map(this.portData, function(data){ return data.timestamp; }).length

      //Calcul des indice en fonction des sélecteur de time span
      firstIndex = Math.round(((parseInt(this.graphTimeCenter)-parseInt(this.graphTimeSpan)/2)/100) * _.map(this.portData, function(data){ return data.timestamp; }).length)
      if (firstIndex < 0 ){firstIndex = 0}
      lastIndex = Math.round(((parseInt(this.graphTimeCenter)+parseInt(this.graphTimeSpan)/2)/100) * _.map(this.portData, function(data){ return data.timestamp; }).length)
      if (lastIndex > _.map(this.portData, function(data){ return data.timestamp; }).length ){lastIndex = _.map(this.portData, function(data){ return data.timestamp; }).length}

      this.graphStartIndex =firstIndex
      this.graphLastIndex =lastIndex

      if (this.selectedDataType == 'peak') {
        changedData = _.map(this.portData, function(data){ return data.peak; }).slice(firstIndex,lastIndex)
      } else if (this.selectedDataType == 'kwh') {
        changedData = _.map(this.portData, function(data){ return data.kwr; }).slice(firstIndex,lastIndex)
      } else if (this.selectedDataType == 'avrPower') {
        changedData = _.map(this.portData, function(data){ return data.avrPower; }).slice(firstIndex,lastIndex)
      } else if (this.selectedDataType == 'cost') {
        changedData = _.map(this.portData, function(data){ return data.cost; }).slice(firstIndex,lastIndex)
      } else if (this.selectedDataType == 'cumSumKwh') {
        changedData = _.map(this.cumulativeSumKWH ).slice(firstIndex,lastIndex)
      } else {
        //changedData = _.map(this.portData, function(data){ return data.cost; })
        changedData = _.map(this.cumulativeSumCost ).slice(firstIndex,lastIndex)
      }

      this.crunchedPowerCall = {
      labels: _.map(this.portData, function(data){ return data.timestamp; }).slice(firstIndex,lastIndex),
      datasets: [{
        label: 'Mesure',
        backgroundColor: 'rgba(70, 195, 123, 0.8)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: changedData
      }]
    }
  },
  
    changeDataForWeatherGraph(value) {
      let changedDataWeather = []
      this.showWeatherGraph = true

      let firstIndex = 0
      let lastIndex = _.map(this.portData, function(data){ return data.timestamp; }).length

      //Calcul des indice en fonction des sélecteur de time span
      firstIndex = Math.round(((parseInt(this.graphTimeCenter)-parseInt(this.graphTimeSpan)/2)/100) * _.map(this.portData, function(data){ return data.timestamp; }).length)
      if (firstIndex < 0 ){firstIndex = 0}
      lastIndex = Math.round(((parseInt(this.graphTimeCenter)+parseInt(this.graphTimeSpan)/2)/100) * _.map(this.portData, function(data){ return data.timestamp; }).length)
      if (lastIndex > _.map(this.portData, function(data){ return data.timestamp; }).length ){lastIndex = _.map(this.portData, function(data){ return data.timestamp; }).length}



      if (this.selectedWeatherType == 'temperature') {
        changedDataWeather = _.map(this.portData, function(data){ return data.temperature; }).slice(firstIndex,lastIndex)
      } else if (this.selectedWeatherType == 'cloud') {
        changedDataWeather = _.map(this.portData, function(data){ return data.cloud; }).slice(firstIndex,lastIndex)
      } else if (this.selectedWeatherType == 'humidity') {
        changedDataWeather = _.map(this.portData, function(data){ return data.humidity; }).slice(firstIndex,lastIndex)
      }else if (this.selectedWeatherType == 'wind') {
        changedDataWeather = _.map(this.portData, function(data){ return data.wind; }).slice(firstIndex,lastIndex)
      }else{this.showWeatherGraph = false}

      this.crunchedWeatherCall = {
      labels: _.map(this.portData, function(data){ return data.timestamp; }).slice(firstIndex,lastIndex),
      datasets: [{
          label: 'Meteo',
          backgroundColor: 'rgba(18, 35, 240, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(18, 35, 240, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(18, 35, 240, 1)',
          data: changedDataWeather
      }]
    }
  },


  refreshGraph(){
      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)
      this.flagGraphDataIsLoading = true
      var requestData = { 'postAction':'GetChannelReadings',
                          'bundleId':this.actualBundle.bundle_id,
                          'channelId':this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
                          'start':this.myStartDateTime,
                          'end':this.myEndDateTime,
                          'dataSampling':this.dataSamplingSelect,
                          }
      //console.log(requestData)

      this.$store.dispatch('sessionStore/postChannel', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
              this.portData = response.data.ChannelReadings

              //We remove weather data if this option is not available
              if(this.profileData.rights.rights.logWeatherFlag==false){
                   for(var i = 0; i < this.portData.length;i++){
                    this.portData[i].temperature = 0
                    this.portData[i].cloud = 0
                    this.portData[i].humidity = 0
                    this.portData[i].wind = 0
                    } 
              }


              this.computeCumulativeSum()
              this.changeDataForGraph('avrPower')
              this.refreshNewGraphData()
              this.flagGraphDataIsLoading = false
              }
              else{
              window.alert(response.data.PromptMessage[this.actualLanguage])
              this.flagGraphDataIsLoading = false}
          })

        this.$store.dispatch('chargesStore/setStartDate', this.myStartDateTime)
        this.$store.dispatch('chargesStore/setEndDate', this.myEndDateTime)
      

      },

  computeCumulativeSum(){
    this.cumulativeSumKWH = _.map(this.portData, function(data){ return data.kwr; })
    var Sum = this.cumulativeSumKWH[0]
    for(var i = 1; i < this.cumulativeSumKWH.length;i++){
      Sum += this.cumulativeSumKWH[i]
      this.cumulativeSumKWH[i]=Sum.toFixed(3)
      this.cumulativeSumKWH[i]=Sum.toFixed(3)
    }
    this.sumKWH=parseFloat(Sum).toFixed(2)

    this.cumulativeSumCost = _.map(this.portData, function(data){ return data.cost; })
    var Sum = this.cumulativeSumCost[0]
    for(var i = 1; i < this.cumulativeSumCost.length;i++){
      Sum += this.cumulativeSumCost[i]
      this.cumulativeSumCost[i]=Sum.toFixed(3)
    }
    this.sumCost = parseFloat(Sum).toFixed(2)

    var currents = _.map(this.portData, function(data){ return data.peakCurrent; })
    this.maxCurrent = 0
    for(var i = 1; i < this.cumulativeSumCost.length;i++){
      if(currents[i]>this.maxCurrent){this.maxCurrent=currents[i].toFixed(1)}
    }
  },




  refreshNewGraphData(){
      this.chartDataSeries = []
      var NewGraphDataTempo = []
      this.flagDisplayNewGraph=false
      var actualValue = 0.0

      if(this.selectAvrPower && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          actualValue = this.portData[i].avrPower/1000
          NewGraphDataTempo.push([this.portData[i].localEpochTime,actualValue.toFixed(3)])
        }
        this.chartDataSeries.push({name:this.labelSelectorAvrPowerKW[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectPeakPower && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          actualValue = this.portData[i].peak/1000
          NewGraphDataTempo.push([this.portData[i].localEpochTime,actualValue.toFixed(3)])
        }
        this.chartDataSeries.push({name:this.labelSelectorPeakPowerKW[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectKWH && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].kwr])
        }
        this.chartDataSeries.push({name:this.labelSelectorKWH[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectCost && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].cost])
        }
        this.chartDataSeries.push({name:this.labelSelectorCost[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectCumSumKwh && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.cumulativeSumKWH[i]])
        }
        this.chartDataSeries.push({name:this.labelSelectorCumSumKWH[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectCumSumCost && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.cumulativeSumCost[i]])
        }
        this.chartDataSeries.push({name:this.labelSelectorCumSumCost[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectTemperature && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].temperature])
        }
        this.chartDataSeries.push({name:this.labelSelectorTemperature[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectHumidity && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].humidity])
        }
        this.chartDataSeries.push({name:this.labelSelectorHumidity[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectCloud && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].cloud])
        }
        this.chartDataSeries.push({name:this.labelSelectorCloud[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }

      if(this.selectWind && this.portData.length > 0){
        NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].wind])
        }
        this.chartDataSeries.push({name:this.labelSelectorWind[this.actualLanguage],
                                  data:NewGraphDataTempo})
      }




      this.flagDisplayNewGraph=true
  },


  formatTimeToUnix(date, time) {
      const unixTime = moment(date)
      .set('hour', time.split(':')[0])
      .set('minute', time.split(':')[1])
      .set('seconds', 0)
      .unix()
      return unixTime
    },



  },
  mounted() {
    //this.portData = this.portData.reverse()
    this.portData = this.actualBundle.channels[this.channelIndex].ChannelData.Readings

    //We remove weather data if this option is not available
    if(this.profileData.rights.rights.logWeatherFlag==false){
          for(var i = 0; i < this.portData.length;i++){
          this.portData[i].temperature = 0
          this.portData[i].cloud = 0
          this.portData[i].humidity = 0
          this.portData[i].wind = 0
          } 
    }



    this.computeCumulativeSum()



    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.myStartDate = new Date(this.startDate * 1000),
    this.myEndDate = new Date(this.endDate * 1000)

    var DateStringSplit = this.myStartDate.toString().split(':')
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]

    DateStringSplit = this.myEndDate.toString().split(':')
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]
    
    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)

    

    this.changeDataForGraph('avrPower')
    this.flagDisplayGraph = true

    //console.log("---Port Data")
    //console.log(this.portData)
    //console.log(_.map(this.portData, function(data){ return data.humidity; }))
    this.refreshNewGraphData()

  /*
    if (this.portData.length > 0){
        var NewGraphDataTempo = []
        for(var i = 0; i < this.portData.length;i++){
          NewGraphDataTempo.push([this.portData[i].localEpochTime,this.portData[i].kwr])
        }
        //console.log(NewGraphDataTempo)
        //console.log(this.series3)
        this.chartDataSeries[0].data = NewGraphDataTempo
        this.flagDisplayNewGraph=true
    }
    */



    
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// PortGraph.vue?0b8b88a0